import { Colors } from "./colors";

export const darkModeField = {
  margin: "0 0 35px",
  input: { color: Colors.secondary },

  "& label.Mui-focused": {
    color: Colors.secondary,
  },
  "& label": {
    color: Colors.secondary,
  },
  "& label.Mui-error": {
    color: Colors.error,
  },
  "& .MuiOutlinedInput-root": {
    "& fieldset": {
      borderColor: Colors.secondary,
    },
    "&:hover fieldset": {
      borderColor: Colors.secondary,
    },
    "&.Mui-focused fieldset": {
      borderColor: Colors.secondary,
    },
  },
  "& .MuiOutlinedInput-root.Mui-error": {
    "& fieldset": {
      borderColor: Colors.error,
    },
    "&:hover fieldset": {
      borderColor: Colors.error,
    },
    "&.Mui-focused fieldset": {
      borderColor: Colors.error,
    },
  },
};

export const darkModePassword = { ...darkModeField, margin: "0" };
